import { Footer, Loader } from '../Widgets';
import React, { useEffect, useState } from 'react'
import { Link, NavLink, useSearchParams } from 'react-router-dom';
import { ProductGroup } from 'service/Models';
import ArthaOnlineServerGateway from 'service/OnlineServerGateway';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import ArthaGateway from 'service/ArthaGateway';
import defaultImage from "../../assets/default.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faGripVertical, faTableList } from '@fortawesome/free-solid-svg-icons';

export const ProductList = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [queryParams, setQueryParams] = useSearchParams();
    const [products, setProducts] = useState<any[]>([]);
    const [productGroups, setProductGroups] = useState<ProductGroup[]>([]);
    const [productBrands, setProductBrands] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [screenMode, setScreenMode] = useState<string>("select-product");
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [totalPages, setTotalPages] = useState<number>(5);
    const [productGroup, setProductGroup] = useState<ProductGroup>();
    const [productBrand, setProductBrand] = useState<any>();
    const [productName, setproductName] = useState<string>("");
    const [selectionMode, setSelectionMode] = useState<string>("table");
    const [productMaster, setProductMaster] = useState<any>(null);
    const [isProductsLoading, setIsProductsLoading] = useState<boolean>(false);

    useEffect(() => {
        productGroups.map((productGroup) => {
            if (productGroup.id.toString() === queryParams.get("id")) {
                setProductGroup(productGroup);
            }
            return productGroup;
        });
    }, [productGroups]);

    useEffect(() => {
        if (products === null || products === undefined || products.length === 0) {
            loadProductGroups();
            loadProductBrands();
        }
        let value = localStorage.getItem("selectionMode");
        if (value) {
            setSelectionMode(value);
        }
    }, []);

    useEffect(() => {
        setProducts([]);
        if (pageNumber != 1) {
            setPageNumber(1);
        }
        else {
            loadProductMasters();
        }
    }, [productGroup, productBrand, productName]);

    const loadProductMasters = () => {
        setIsLoading(true);
        ArthaGateway
            .getProductMasters(0, 0, productName, true)
            .then((data) => {
                setProducts(data.entries.filter(p => p.enableOnlineSales == true));

                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
        //}
    }

    const loadProductBrands = () => {
        if (productBrands.length > 0) {
            return;
        }
        ArthaGateway
            .getProductBrands()
            .then((data) => {
                data.forEach(element => {
                    element.products = [];
                });
                //data.unshift({ id: 0, name: "All" });
                sessionStorage.setItem("brands", JSON.stringify(data));
                setProductBrands(data);
                setProductBrand(data[0]);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadProductGroups = () => {
        if (productGroups.length > 0) {
            return;
        }
        if (sessionStorage.getItem("catagories") === null) {
            ArthaGateway
                .getProductGroups()
                .then((data) => {
                    data = data.filter(g => g.id !== 999);
                    data.forEach(element => {
                        element.products = [];
                    });
                    //data.unshift({ id: 0, name: "All" });
                    sessionStorage.setItem("catagories", JSON.stringify(data));
                    setProductGroups(data);
                    setProductGroup(data[0]);
                })
                .catch(error => {
                    console.log(error);
                    setIsLoading(false);
                });
        }
        else {
            let localData = sessionStorage.getItem("catagories");
            if (localData) {
                let catagories = JSON.parse(localData);
                setProductGroups(catagories);
                setProductGroup(catagories[0]);
            }
        }
    }

    return (
        <div className="page page-product-list">
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <h1>Products</h1>
                    {screenMode === "select-product" &&
                        <>
                            <div className='form-group' style={{ marginBottom: "10px" }}>
                                <label>Name</label>
                                <input
                                    className='form-control'
                                    value={productName}
                                    onChange={(e) => setproductName(e.target.value)} />
                            </div>
                            <div className="products-holder">
                                <div className='row mt-0'>
                                    <div className="btn-group btn-group-toggle w-100 p-0" data-toggle="buttons">
                                        <div className={"btn " + ((selectionMode != "table") ? "btn-secondary" : "btn-dark") + " btn-sm w-50"} onClick={() => setSelectionMode("grid")}><FontAwesomeIcon icon={faGripVertical}></FontAwesomeIcon> </div>
                                        <div className={"btn " + ((selectionMode != "grid") ? "btn-secondary" : "btn-dark") + " btn-sm w-50"} onClick={() => setSelectionMode("table")}><FontAwesomeIcon icon={faTableList}></FontAwesomeIcon> </div>
                                    </div>
                                </div>
                                {productBrands && productBrands.length > 0 && (
                                    <div className="accordion" id="brandsAccordion">
                                        {productBrands.map((brand, i) => (
                                            <>
                                                {products.filter(product => product.brandId === brand.id).length > 0 && (
                                                    <div className="accordion-item" key={brand.id}>
                                                        <h2 className="accordion-header" id={`brandHeading${i}`}>
                                                            <button
                                                                className={`accordion-button${i !== 0 ? " collapsed" : ""}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#brandCollapse${i}`}
                                                                aria-expanded={i === 0 ? "true" : "false"}
                                                                aria-controls={`brandCollapse${i}`}
                                                            >
                                                                <b>{brand.name}</b> &nbsp; ({products.filter(product => product.brandId === brand.id).length} products)
                                                            </button>
                                                        </h2>
                                                        <div
                                                            id={`brandCollapse${i}`}
                                                            className={`accordion-collapse collapse${i === 0 ? " show" : ""}`}
                                                            aria-labelledby={`brandHeading${i}`}
                                                            data-bs-parent="#brandsAccordion"
                                                        >
                                                            <div className="accordion-body">
                                                                {selectionMode === "table" ? (
                                                                    <div className="products row">
                                                                        <table className="table table-sm products-table px-2">
                                                                            <tbody>
                                                                                {products
                                                                                    .filter((product) => product.brandId === brand.id)
                                                                                    .map((product, index) => (
                                                                                        <tr key={product.id || index}>
                                                                                            <td className="px-2">{product.name}</td>
                                                                                            <td style={{ width: "120px", textAlign: "right", padding: 0 }}>
                                                                                                <NavLink
                                                                                                    className="btn btn-dark btn-sm w-100 mt-auto"
                                                                                                    to={'/product/' + product.id}
                                                                                                >Details</NavLink>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : (
                                                                    <div className="products row">
                                                                        {products
                                                                            .filter((product) => product.brandId === brand.id)
                                                                            .map((product, index) => (
                                                                                <div key={product.id || index} className="col-6 col-md-4 col-lg-3">
                                                                                    <div className="card mt-2">
                                                                                        <div className="card-img-top text-center">
                                                                                            <img
                                                                                                src={
                                                                                                    product?.imageUrl && product?.imageUrl.length > 0
                                                                                                        ? product.imageUrl
                                                                                                        : defaultImage
                                                                                                }
                                                                                                alt="product"
                                                                                                style={{ maxHeight: "250px", width: "100%", objectFit: "cover" }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="card-body d-flex flex-column p-1">
                                                                                            <div className="card-title">{product.name}</div>
                                                                                            <NavLink
                                                                                                className="btn btn-dark btn-sm w-100 mt-auto"
                                                                                                to={'/product/' + product.id}
                                                                                            >Details</NavLink>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        ))}
                                    </div>
                                )}

                                {(totalPages > pageNumber) &&
                                    <>
                                        {isProductsLoading &&
                                            <div className="btn btn-dark w-100 text-center m-4">
                                                <div className="spinner-border text-light" role="status">
                                                </div>
                                            </div>
                                        }
                                        {!isProductsLoading &&
                                            <div className="btn btn-dark w-100 text-center mt-4" onClick={() => setPageNumber(pageNumber + 1)}>Load More...</div>
                                        }
                                    </>
                                }
                            </div>
                            <div className='btn btn-danger back-to-home' onClick={() => setScreenMode("main-screen")}>
                                <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: 10 }} />
                            </div>
                        </>
                    }
                </>
            }
            <NavLink className="btn btn-sm bg-danger btn-back-to-home" to="/productCategory">Back</NavLink>
        </div>

    )
}